import { TLCEventManager } from "../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../js/main/constants";

export const SpeechTranscriptions = {
	"en-US": {
		'DEFAULT':            function( transcript ) {
			TLCEventManager.fireEvent( LS2PAC_CONSTANTS.Events.onSearch, {
				searchString: transcript,
				noHistory:    true
			} );
		},
		'my account':         function() {
			SpeechTranscriptions._goToMyAccount( {} );
		},
		'home':               function() {
			setTimeout( function() {
				TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onHome );
			}, 1 );
		},
		'log out':            LS2PAC_CONSTANTS.Events.onLogout,
		'login':              LS2PAC_CONSTANTS.Events.onPromptForLogin,
		'my list':            function() {
			SpeechTranscriptions._goToMyAccount( {
				view: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.myLists
			} );
		},
		'hold':               function() {
			SpeechTranscriptions._goToMyAccount( {
				view:    LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.accountActivity,
				subView: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.holds
			} );
		},
		'saved searches':     function() {
			SpeechTranscriptions._goToMyAccount( {
				view: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.mySearches
			} );
		},
		'my search':          function() {
			SpeechTranscriptions._goToMyAccount( {
				view: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.mySearches
			} );
		},
		'my fines':           function() {
			SpeechTranscriptions._goToMyAccount( {
				view:    LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.accountActivity,
				subView: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.fines
			} );
		},
		'login autocomplete': function() {
			TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onPromptForLogin );
			setTimeout( function() {
				$( '#loginForm' ).trigger("submit");
			}, 2000 );
		}
	},
	"es-US": {
		'DEFAULT':        function( transcript ) {
			return this._transcriptions['en-US']['DEFAULT'].call( this, transcript );
		},
		'mi cuenta':      function() {
			SpeechTranscriptions._goToMyAccount( {} );
		},
		'casa':           LS2PAC_CONSTANTS.Events.onHome,
		'log out':        LS2PAC_CONSTANTS.Events.onLogout,
		'login':          LS2PAC_CONSTANTS.Events.onPromptForLogin,
		'mis listas':     function() {
			SpeechTranscriptions._goToMyAccount( {
				view: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.myLists
			} );
		},
		'mantener':       function() {
			SpeechTranscriptions._goToMyAccount( {
				view:    LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.accountActivity,
				subView: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.holds
			} );
		},
		'saved searches': function() {
			SpeechTranscriptions._goToMyAccount( {
				view: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.mySearches
			} );
		},
		'my search':      function() {
			SpeechTranscriptions._goToMyAccount( {
				view: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.mySearches
			} );
		},
		'mis multas':     function() {
			SpeechTranscriptions._goToMyAccount( {
				view:    LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.accountActivity,
				subView: LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.fines
			} );
		}
	}
};


/**
 * Helper function to go to a my account section
 * @param eventArguments
 * @private
 */
SpeechTranscriptions._goToMyAccount = function( eventArguments ) {
	if( eventArguments.subView == "requests" ) {
		eventArguments.subView = "holds";
	}

	TLCEventManager.fireEvent( LS2PAC_CONSTANTS.Events.onMyAccount, eventArguments );
};